import axios from "axios";
import { plainToClass } from "class-transformer";
import { validate } from "class-validator";
import { MutateFactDTO } from "../../dto";

type ModifyFactProps = {
  id: number;
  title: string;
  description: string;
};

let body: MutateFactDTO;

export async function modifyFactAction(props: ModifyFactProps) {
  const token = localStorage.getItem("token");

  const params = {
    id: props.id,
    description: props.description,
    title: props.title,
  };

  return await axios
    .patch(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/facts/modify`,
      params,
      {
        headers: {
          "Content-Type": "application/json",
          "app-platform": "cms",
          Authorization: `Bearer ${token}`,
        },
      }
    )
    .then(async (res) => {
      body = plainToClass(MutateFactDTO, res.data);
      await validate(body);
      const errors = await validate(body);
      if (errors.length > 0) {
        throw errors;
      }

      return res.data;
    });
}
